module.exports = __webpack_public_path__ + "media/images/why-ih-3-4c3e56327c23af064a3226667ef7f1b0.svg";